import { ChangeHeadOfficeAddressDetails } from 'services/ApiService/Franfinance/FranfinanceApiClient';
import { Reducer } from 'store/configureStore';
import { ApiRequest } from 'store/sharedModels';

export const changeHeadOfficeAddressInitialState = {
    results: {} as { [id: string]: ApiRequest<ChangeHeadOfficeAddressDetails> },
} as const;

type ChangeHeadOfficeAddressState = typeof changeHeadOfficeAddressInitialState;

export const ChangeHeadOfficeAddressReducer: Reducer<ChangeHeadOfficeAddressState> = (state = changeHeadOfficeAddressInitialState, action) => {
    switch (action.type) {
        case '@CUSTOMER_REQUEST_DETAILS/CHANGE/HEAD_OFFICE_ADDRESS/GET':
            return {
                ...state,
                results: {
                    ...state.results,
                    [action.payload.caseId]: {
                        isFetching: true,
                        didInvalidate: true,
                    },
                },
            };
        case '@CUSTOMER_REQUEST_DETAILS/CHANGE/HEAD_OFFICE_ADDRESS/GET_SUCCESS':
            return {
                ...state,
                results: {
                    ...state.results,
                    [action.payload.caseId]: {
                        isFetching: false,
                        didInvalidate: false,
                    },
                },
            };
        case '@CUSTOMER_REQUEST_DETAILS/CHANGE/HEAD_OFFICE_ADDRESS/GET_FAILURE':
            return {
                ...state,
                results: {
                    ...state.results,
                    [action.payload.caseId]: {
                        isFetching: false,
                        didInvalidate: true,
                    },
                },
            };
        case '@CUSTOMER_SERVICE_DETAILS_RESPONSE/INSTRUCTION/SUBMIT_SUCCESS':
            return {
                ...state,
                results: {
                    ...state.results,
                    [action.payload.caseId]: {
                        isFetching: false,
                        didInvalidate: true,
                    },
                },
            };
        case '@CUSTOMER_SERVICE_DETAILS_RESPONSE/NON_COMPLIANCE/SUBMIT_SUCCESS':
            return {
                ...state,
                results: {
                    ...state.results,
                    [action.payload.caseId]: {
                        isFetching: false,
                        didInvalidate: true,
                    },
                },
            };
        default:
            return state;

    }
};